import React from 'react';

const VenuesIcon = () => (
  <svg width="24" height="24" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.67383 16.8721H14.3174C16.2158 16.8721 17.2002 15.8877 17.2002 14.0156V3.31934C17.2002 1.43848 16.2158 0.462891 14.3174 0.462891H3.67383C1.77539 0.462891 0.791016 1.43848 0.791016 3.31934V14.0156C0.791016 15.8965 1.77539 16.8721 3.67383 16.8721ZM3.7793 15.1494C2.96191 15.1494 2.51367 14.7188 2.51367 13.8662V3.45996C2.51367 2.60742 2.96191 2.18555 3.7793 2.18555H14.2119C15.0205 2.18555 15.4775 2.60742 15.4775 3.45996V13.8662C15.4775 14.7188 15.0205 15.1494 14.2119 15.1494H3.7793ZM4.54395 9.38379H8.05957C8.22656 9.38379 8.34082 9.49805 8.34082 9.67383V13.1455C8.34082 13.9541 9.22852 14.0947 9.53613 13.4355L13.2627 5.44629C13.5967 4.73438 12.9639 4.10156 12.2344 4.43555L4.2627 8.18848C3.60352 8.50488 3.75293 9.38379 4.54395 9.38379Z"
      fill="var(--icon-color)"
    />
  </svg>
);

export default VenuesIcon;
